/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForAzureEaApplicationMaster extends models.ServiceAccountNativeDetailsBaseForAzureEaMaster {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForAzureEaApplicationMaster");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForAzureEaApplicationMaster.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForAzureEaApplicationMaster>): ServiceAccountNativeDetailsForAzureEaApplicationMaster {
        let obj = Object.assign(new ServiceAccountNativeDetailsForAzureEaApplicationMaster(), model);
        ServiceAccountNativeDetailsForAzureEaApplicationMaster.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForAzureEaApplicationMaster>): ServiceAccountNativeDetailsForAzureEaApplicationMaster {
        if (!model) return null;
        return ServiceAccountNativeDetailsForAzureEaApplicationMaster.newInstance(<ServiceAccountNativeDetailsForAzureEaApplicationMaster> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForAzureEaApplicationMaster) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForAzureEaApplicationMaster.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForAzureEaApplicationMaster): boolean {
        if (models.ServiceAccountNativeDetailsBaseForAzureEaMaster.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForAzureEaApplicationMaster.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Subscription Id in which cost export configured. This is a required field.
     */
    subscription_id: string;

    /**
     * Storage account name configured in cost export. This is a required field.
     */
    storage_account: string;

    /**
     * Report path for actual cost. This is a required field. Eg. {container_name}/{directory_path}/{export_report_name}.
     */
    report_path: string;

    /**
     * Report path for amortized cost. This is a optional field. Eg. {container_name}/{directory_path}/{export_report_name}.
     */
    amortized_report_path: string;

}
